import { generateClassName } from '@klv/shared/utils/functions';
import { useTranslation } from '@klv/hooks/useTranslation';
import { useModal } from '@klv/context/modal';
import TextLink from '@klv/atoms/text-link';

import * as s from './styles/ctaLegalLanguages.module.css';

import type { ICTALegalLanguage } from './types';

const CTALegalLanguage = ({ formType, ...props }: ICTALegalLanguage) => {
  const { t } = useTranslation();
  const colorVariant = props.colorVariant || 'light';
  const modalStore = useModal();
  const notSupportedLocale = ['fr'].includes(t('langCodes_pathPrefix'));

  return (
    <div className={generateClassName([s.legalLanguage, "formSmall"])} {...props}>
      {((formType === 'signup') || (formType === 'demo' && !notSupportedLocale)) && (
        <div className={generateClassName([s.termsSection, s[colorVariant], "formRegular"])}>
          {t('organisms_forms_legal_acknowledgement')}
          {' '}
          {formType !== 'demo' &&
            <><TextLink $colorVariant={colorVariant} tabIndex={0} href={t('organisms_forms_legal_termsOfService_href')} target='_blank' onClick={() => modalStore.close()}>{t('organisms_forms_legal_termsOfService')}</TextLink>
              {' '}
              {t('organisms_forms_legal_and')}
              {' '}
            </>}
          <TextLink tabIndex={0} href={t('organisms_forms_legal_privacyPolicy_href')} target='_blank' onClick={() => modalStore.close()}>{t('organisms_forms_legal_privacyPolicy_label')}</TextLink>
          .
        </div>
      )}

      {(formType === 'demo' && t('langCodes_pathPrefix') === 'fr') && (
        <div className={generateClassName([s.termsSection, s[colorVariant], "formRegular"])}>
          {t('organisms_forms_legal_agreeToTermsOfService')} {' '}
          <TextLink $colorVariant={colorVariant} tabIndex={0} href={t('organisms_forms_legal_termsOfService_href')} target='_blank' onClick={() => modalStore.close()}>{t('organisms_forms_legal_agreeTermsLinkText')}</TextLink>
          {' '}
          {t('organisms_forms_legal_and')}
          {' '}
          <TextLink $colorVariant={colorVariant} tabIndex={0} href={t('organisms_forms_legal_codeOfConduct_href')} target='_blank' onClick={() => modalStore.close()}>{t('organisms_forms_legal_agreeToPartnerCodeOfConduct')}</TextLink>
        </div>
      )}
    </div>
  );
};

export default CTALegalLanguage;
